import { defaultGrid } from "@helpers/datagrid";
import defaultReducer from "./defaultReducer";

const initialState = {
  title: "Cash In Box",
  open: false,
  ...defaultGrid,
  onRefresh: () => {},
  activeRow: {
    installationId: null,
  },
  eventsFn: async () => {},
};

export default defaultReducer("SITE_DETAILS_MODAL", initialState);
